import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    orders: {
      unfreeze: {
        today: [],
        tomorrow: [],
        aftertomorrow: [],
      },
      total: []
    },
    dates: {unfreeze: '', total: ''},
    future_totals: {
      days_3: {
        date: '',
        orders: 0
      },
      days_4: {
        date: '',
        orders: 0
      }
    },
    week_state: {
      products: [],
      totals: []
    },
    isLoading: false
  },

  getters: {
    orders (state) {
      let orders = state.orders.total
      orders.sort((a, b) => (a.external_created_at > b.external_created_at) ? -1 : 1)
      return orders
    },
    ordersUnfreezePerCat (state) {
      let cats = {}
      for(const unfreezeKey in state.orders.unfreeze) {
        cats[unfreezeKey] = {};
        let section = state.orders.unfreeze[unfreezeKey];
        for(const sectionKey in section) {
          let order = section[sectionKey];
          for(const orderKey in order.products) {
            let product = order.products[orderKey];
            if (!cats[unfreezeKey][product.title]) {
              cats[unfreezeKey][product.title] = []
            }
            cats[unfreezeKey][product.title].push(order)
          }
        }
      }
      return cats
    },
    productsUnfreezePerCat (state) {
      let cats = {}
      let productsPerCat = []
      for(const unfreezeKey in state.orders.unfreeze) {
        cats[unfreezeKey] = {};
        let section = state.orders.unfreeze[unfreezeKey];
        for(const sectionKey in section) {
          let order = section[sectionKey];
          for(const orderKey in order.products) {
            let product = order.products[orderKey];
            if (!cats[unfreezeKey][product.title]) {
              cats[unfreezeKey][product.title] = 0
            }
            cats[unfreezeKey][product.title] += product.quantity
          }
        }
        productsPerCat[unfreezeKey] = Object.keys(cats[unfreezeKey]).sort().reduce(function (result, key) {
          result[key] = cats[unfreezeKey][key];
          return result
        }, {});
      }
      return productsPerCat
    },
    date (state) {
      return state.dates.total
    },
    dateUnfreeze (state) {
      return state.dates.unfreeze
    },
    futureTotals (state) {
      return state.future_totals
    },
    weekState (state) {
      return state.week_state
    },
    isLoading (state) {
      return state.isLoading
    }
  },

  mutations: {
    ADD (state, params) {
      if(params.section) {
        Vue.set(state.orders[params.cat][params.section], state.orders[params.cat][params.section].length, params.order)
      } else {
        Vue.set(state.orders[params.cat], state.orders[params.cat].length, params.order)
      }
    },

    UPDATE (state, params) {
      for(let i = 0; i < state.orders[params.cat].length; i++) {
        if(state.orders[params.cat][i].id === params.order.id) {
          Vue.set(state.orders[params.cat], i, params.order)
          break;
        }
      }
    },

    REMOVE (state, params) {
      for(let i = 0; i < state.orders[params.cat].length; i++) {
        if(state.orders[params.cat][i].id === params.order.id) {
          state.orders[params.cat].splice(i, 1)
          break;
        }
      }
    },

    ADDFUTURE (state, params) {
      Vue.set(state.future_totals[params.cat].orders, state.future_totals[params.cat].orders + 1)
    },

    REMOVEFUTURE (state, params) {
      Vue.set(state.future_totals[params.cat].orders, state.future_totals[params.cat].orders - 1)
    },

    CLEARALL (state) {
      state.orders = {
        unfreeze: {
          today: [],
          tomorrow: [],
          aftertomorrow: [],
        },
        total: []
      }
    },

    SETDATE (state, params) {
      state.dates[params.cat] = params.date
    },

    SETFUTURETOTALS (state, data) {
      state.future_totals.days_3.date = data.dates.days_3
      state.future_totals.days_3.orders = data.orders.days_3
      state.future_totals.days_4.date = data.dates.days_4
      state.future_totals.days_4.orders = data.orders.days_4
    },

    SETWEEKSTATE (state, data) {
      state.week_state = data
    },

    ISLOADING (state, isLoading) {
      state.isLoading = isLoading
    }
  },

  actions: {
    loading({ commit }, isLoading) {
      this.commit('orders/ISLOADING', isLoading);
    },
    async getOrders ({ dispatch }) {
      let that = this

      this.commit('orders/CLEARALL');

      Vue.axios.get('/api/order/tomorrow').then((response) => {
        if(response.data.date) {
          that.commit('orders/SETDATE', {date: response.data.date, cat: 'total'})
        }

        for(let i = 0; i < response.data.orders.length; i++) {
          that.commit('orders/ADD', {order: response.data.orders[i], cat: 'total'})
        }
      }).catch(() => {
        // do nothing
      })
      Vue.axios.get('/api/order/unfreezedayaftertomorrow').then((response) => {
        if(response.data.date) {
          that.commit('orders/SETDATE', {date: response.data.date, cat: 'unfreeze'})
        }

        if(response.data.orders.today) {
          for(let i = 0; i < response.data.orders.today.length; i++) {
            that.commit('orders/ADD', {order: response.data.orders.today[i], cat: 'unfreeze', section: 'today'})
          }
        }

        if(response.data.orders.tomorrow) {
          for (let i = 0; i < response.data.orders.tomorrow.length; i++) {
            that.commit('orders/ADD', {order: response.data.orders.tomorrow[i], cat: 'unfreeze', section: 'tomorrow'})
          }
        }

        if(response.data.orders.aftertomorrow) {
          for (let i = 0; i < response.data.orders.aftertomorrow.length; i++) {
            that.commit('orders/ADD', {order: response.data.orders.aftertomorrow[i], cat: 'unfreeze', section: 'aftertomorrow'})
          }
        }
      }).catch(() => {
        // do nothing
      })
      Vue.axios.get('/api/order/futuretotals').then((response) => {
        if(response.data) {
          that.commit('orders/SETFUTURETOTALS', response.data)
        }
      }).catch(() => {
        // do nothing
      })
    },

    async getWeekState ({ dispatch }) {
      let that = this


      Vue.axios.get('/api/order/weekstate').then((response) => {
        if(response.data) {
          that.commit('orders/SETWEEKSTATE', response.data)
        }
      }).catch(() => {
        // do nothing
      })
    }
  }
}
